<template>
  <transition name="fade">
    <div
      v-show="isShow"
      class="c-modal"
      @click.stop.prevent="$emit('close-modal')"
    >
      <div :class="['c-modal__content', styleType]" @click.stop>
        <button
          type="button"
          class="c-modal__close-button"
          @click.stop.prevent="$emit('close-modal')"
        >
          ×
        </button>
        <div class="c-modal__container">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ComponentModal',
  props: {
    isShow: { type: Boolean, default: false },
    styleType: { type: String, default: '' },
  },
  watch: {
    isShow(isShow) {
      document.body.style.overflow = isShow ? 'hidden' : null
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-modal {
  align-items: center;
  background: rgba(#000, 0.7);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed;
  top: 0;
  transition: 0.3s;
  width: 100vw;
  z-index: variables.$z-index-modal;

  &.fade-enter-from,
  &.fade-leave-to {
    opacity: 0;
  }

  &__content {
    background-color: #fff;
    border-radius: 8px;
    padding: 32px 20px;
    position: relative;

    &.pink {
      background-color: variables.$color-accent-weak;
      border-radius: 24px;
    }

    @include mixins.screen-desktop {
      min-width: 560px;
    }
  }

  &__container {
    max-height: 75vh;
    overflow-y: scroll;
  }

  &__close-button {
    bottom: 100%;
    color: #fff;
    cursor: pointer;
    font-size: 32px;
    padding: 4px;
    position: absolute;
    right: 0;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.6;
    }
  }
}
</style>
